module.exports = __webpack_public_path__ + "img/arrow-down_y.770904dc.svg";